export type BrokerOrderId = string | number;
export type SuccessResult<T> = { success: true } & T;
export type ErrorResult = { success: false } & { error?: { reason?: string, message?: string } };
export type MarginCalculation = {
  totalMarginAvailable: number,
  totalMarginRequired: number
}

/* eslint-disable @typescript-eslint/naming-convention */
export enum Segments {
  EQ = 'EQ', // Equity
  FUT = 'FUT', // Futures
  OPT = 'OPT', // Options
}


export enum OrderTypes {
  MARKET = 'MARKET',
  LIMIT = 'LIMIT',
  SL_L = 'SL_L', // Stop Loss Limit
  SL_M = 'SL_M', // Stop Loss Market
}


export enum ProductTypes {
  CNC = 'CNC',
  MIS = 'MIS',
  NRML = 'NRML'
}

export enum TransactionType {
  BUY = 'BUY',
  SELL = 'SELL'
}

export enum OptionTypes {
  CE = 'CE',
  PE = 'PE'
}

export enum Exchanges {
  NSE = 'NSE',
  NFO = 'NFO',
  BSE = 'BSE',
  BFO = 'BFO'
};

export enum OrderStatus {
  CANCELLED = 'CANCELLED',
  TRADED = 'TRADED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  EXPIRED = 'EXPIRED',
}


